import { render } from "./Text.vue?vue&type=template&id=bfcf9806"
import script from "./Text.vue?vue&type=script&setup=true&lang=js"
export * from "./Text.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Filter/Types/Text.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfcf9806"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfcf9806', __exports__)) {
    api.reload('bfcf9806', __exports__)
  }
  
  module.hot.accept("./Text.vue?vue&type=template&id=bfcf9806", () => {
    api.rerender('bfcf9806', render)
  })

}


export default __exports__